/* Întrebarea este copiată numai la acțiunea vizitatorului. */
(function () {
  function init(root) {
    root.querySelectorAll('[data-aeol-ai]').forEach(function (widget) {
      if (widget.dataset.aeolInitialized) return;
      widget.dataset.aeolInitialized = 'true';
      const prompt = widget.querySelector('[data-aeol-prompt]').textContent.trim();
      const feedback = widget.querySelector('[data-aeol-feedback]');
      async function copy(gemini) {
        try {
          await navigator.clipboard.writeText(prompt);
          feedback.textContent = gemini ? 'Întrebarea a fost copiată. Lipește-o în Gemini.' : 'Întrebarea a fost copiată.';
        } catch (error) {
          widget.querySelector('details').open = true;
          feedback.textContent = 'Selectează și copiază întrebarea de mai sus, apoi lipește-o în conversație.';
        }
      }
      widget.querySelector('[data-aeol-copy]').addEventListener('click', function () { copy(false); });
      widget.querySelector('[data-aeol-gemini]').addEventListener('click', function () { copy(true); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
